<po-page-list
  #pageListComponent
  [p-breadcrumb]="breadcrumb"
  p-title="Convenções Sindicais"
  [p-actions]="pageActions"
  p-subtitle="Consulte e acompanhe documentos de convenções coletivas de trabalho.">
  <div class="page-summary">
    <div class="page-summary-icon">
      <i class="an an-file-text"></i>
    </div>
    <div class="page-summary-text">
      <p class="po-font-subtitle po-mb-0">Documentos de Convenções Coletivas</p>
      <p class="page-summary-hint">
        Consulte as convenções coletivas disponibilizadas no sistema Mediador do Ministério do
        Trabalho e Emprego. Nesta página, você pode acompanhar os documentos por número de registro
        e acessar os arquivos processados de forma prática e centralizada.
      </p>
    </div>
  </div>

  <po-divider></po-divider>

  <div class="section-card po-mt-3">
    <div class="section-card-header">
      <i class="an an-funnel"></i>
      <span>Filtrar por abrangência</span>
    </div>
    <div class="section-card-body">
      <p class="section-hint">
        Selecione o estado e, se quiser, refine pela cidade. Em São Paulo, use a opção
        <b>ABC</b> para Santo André, São Bernardo e São Caetano juntos. As demais cidades
        disponíveis são as já carregadas na listagem — use "Carregar mais" para ampliar as
        opções. O botão "Relatório" baixa um ZIP com os PDFs que atendem a estes filtros.
      </p>
      <div class="po-row section-actions">
        <po-select
          class="po-lg-3 po-md-6 po-sm-12"
          name="filtroUf"
          p-label="Estado"
          p-placeholder="Todos os estados"
          p-clean="true"
          [p-options]="estadoOptions"
          [ngModel]="filtroUf"
          (p-change)="onChangeFiltroUf($event)">
        </po-select>
        <po-select
          class="po-lg-3 po-md-6 po-sm-12"
          name="filtroCidade"
          p-label="Cidade"
          p-placeholder="Todas as cidades"
          p-clean="true"
          [p-disabled]="!filtroUf"
          [p-options]="cidadeOptions"
          [ngModel]="filtroCidade"
          (p-change)="onChangeFiltroCidade($event)">
        </po-select>
        <div class="section-button-wrap po-lg-3 po-md-6 po-sm-12">
          <span class="section-button-spacer" aria-hidden="true">&nbsp;</span>
          <po-button
            p-kind="secondary"
            p-icon="an an-x-circle"
            p-label="Limpar filtros"
            [p-disabled]="!temFiltroAtivo"
            (p-click)="limparFiltros()">
          </po-button>
        </div>
      </div>
    </div>
  </div>

  <div class="po-row po-mt-3 po-mb-4 shadow">
    <div>
      <po-loading-overlay [hidden]="isHideLoading"></po-loading-overlay>
    </div>
    <po-table
      class="po-mr-1 po-ml-1 po-lg-12"
      p-container="border"
      p-striped="true"
      p-text-wrap="true"
      p-hide-columns-manager="false"
      [p-spacing]="poTableColumnSpacing"
      [p-columns]="columns"
      [p-items]="items"
      [p-actions]="tableActions"
      (p-show-more)="loadMore()"
      [p-show-more-disabled]="!moreItens"
      [p-loading-show-more]="!isHideLoading">
      <ng-template p-table-column-template [p-property]="'tags'" let-value>
        <ng-container *ngIf="tagsParaBadges(value) as badges">
          <ng-container *ngIf="badges.length > 0; else semTags">
            <span
              *ngFor="let badge of badges"
              class="tag-badge"
              [ngStyle]="estiloBadge(badge)">
              {{ badge.label }}
            </span>
          </ng-container>
        </ng-container>
        <ng-template #semTags>—</ng-template>
      </ng-template>
    </po-table>
  </div>
</po-page-list>

<po-modal
  #modalRelatorio
  p-size="md"
  p-title="Relatório de Convenções Sindicais"
  p-icon="an an-tray-arrow-down"
  p-click-out="false">
  <p class="po-font-subtitle">Confirme a abrangência antes de gerar o arquivo.</p>

  <po-divider></po-divider>

  <p class="po-font-text-large">Estado: <b>{{ estadoSelecionadoDescricao }}</b></p>
  <p class="po-font-text-large">Cidade: <b>{{ cidadeSelecionadaDescricao }}</b></p>

  <po-divider class="po-mt-3"></po-divider>

  <p class="po-font-text-large">Nesta etapa o sistema tentará realizar as seguintes operações:</p>
  <p><b>&nbsp;&nbsp; - Localizar as convenções sindicais da abrangência acima.</b></p>
  <p><b>&nbsp;&nbsp; - Fazer o download dos PDFs em uma pasta .zip.</b></p>

  <p class="po-font-text po-mt-3">
    Somente documentos com as tags de abrangência entram no arquivo. Se nada for encontrado,
    o sistema avisa e nenhum download é iniciado.
  </p>

  <po-modal-footer>
    <po-button
      p-label="Cancelar"
      p-kind="secondary"
      [p-disabled]="isGeneratingReport"
      (p-click)="modalRelatorio.close()">
    </po-button>
    <po-button
      p-label="Gerar relatório"
      p-kind="primary"
      [p-loading]="isGeneratingReport"
      [p-disabled]="!podeGerarRelatorio"
      (p-click)="gerarRelatorio()">
    </po-button>
  </po-modal-footer>
</po-modal>
